import * as types from '../types';

const INITIAL_STATE = {
  id: null,
  name: null,
  orderUnique: true,
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.INIT_PAYMENT: {
      const { shop_id: id = null } = action.payload;

      return {
        ...state,
        id,
        name: null,
        orderUnique: true,
      };
    }
    case types.VERIFICATION_SUCCESS: {
      const { name, checkUniqueOrderId } = action.payload;

      return {
        ...state,
        name,
        orderUnique: !!checkUniqueOrderId,
      };
    }
    default:
      return state;
  }
}
